import React from "react";
import {Form} from "./form";
import "../../styles/paymentDetailsForm.css";
import { getLandRegistarReport,getlandRegistarReceipt, sendConfirmationEmail } from "../../services/reportService";
import { showProgressBar } from "../../services/uiService";
import { hideProgressBar } from "../../services/uiService";
import ShortValueField from "../fields/shortValueField";
import {BrowserView, MobileView} from 'react-device-detect';
import {isBrowser,isMobile} from 'react-device-detect';
//import SpinnerModal from './SpinnerModal';
import {loadImage} from "../../services/uiService";
import { ConfigContext } from "./../../context/ConfigContext";

import { connect } from 'react-redux';
import {store} from './../../../store';
import { selectConfig } from "./../../redux/slices/configSlice";
import { setIsLoading, setReportReceiptData, setReportLandData } from './../../redux/slices/paymentSlice';

class PaymentConfirmForm extends Form {
  static contextType = ConfigContext;
  moduleName = "LAND";

  /* before redux
  state = {
    reportReceiptData:"",
    reportLandData:"",
    isLoading: false
  };
  */
  
  
  showProgressBar() {
    var progressbarImg = document.createElement("img");
    progressbarImg.id = "progressBarImage";
    progressbarImg.className = "ProgressBar";
    progressbarImg.src = loadImage("loading.gif");
    if(isBrowser){
      progressbarImg.style.position = "fixed";
      progressbarImg.style.top = "50%";
      progressbarImg.style.left = "50%";
      progressbarImg.style.marginTop = "-50px";
      progressbarImg.style.marginLeft = "-50px";
    }
    if(isMobile){
      progressbarImg.style.position = "fixed";
      progressbarImg.style.top = "50%";
      progressbarImg.style.left = ((window.innerWidth / 2)- 24).toString() + "px";
    }
    progressbarImg.style.zIndex = "200";
    var root = document.getElementById("root");
    root.appendChild(progressbarImg);
  }

  hideProgressBar() {
    var progressBarImage = document.getElementById("progressBarImage");
    if (progressBarImage) {
      progressBarImage.remove();
    }
  }


  componentDidMount() {
    
    //this.handleOnClick();
  
    this.props.setIsLoading(true);
    // redux this.setState({ isLoading: true });
    this.showProgressBar();
    this.yourAsyncFunction() // Replace yourAsyncFunction with your actual function
      .then(() => {
        // Function completed, hide spinner
        //redux this.setState({ isLoading: false });
        this.props.setIsLoading(false);
        this.hideProgressBar();
      })
      .catch((error) => {
        // Handle error and hide spinner
        console.error("Error:", error);
        //redux this.setState({ isLoading: false });
        this.props.setIsLoading(false);
        this.hideProgressBar();
      });
    
  
  }

  yourAsyncFunction= async () => {
    //showProgressBar();

    let {reportReceiptData, reportLandData} = this.props;

    try {
      reportLandData = await getLandRegistarReport(this.context.reportsEndPoint, this.props.propertyNum);
    
      let isZilmisUser = this.props.OwnerId > 0 ? 1 : 0;
      let recieptId = this.props.ReceiptId;
      let billingDetails = this.props.BillingDetails;
  
      console.log('PaymentConfirmForm-> isZilmisUser: ' + isZilmisUser + ',recieptId: ' + recieptId + ',billingDetails: '+ billingDetails);
  
      if (recieptId !== undefined && recieptId!== 0)
      {
        reportReceiptData = await getlandRegistarReceipt(this.context.reportsEndPoint, isZilmisUser,recieptId,billingDetails);
        //redux this.setState({reportReceiptData, reportLandData});
        this.props.setReportLandData(reportLandData);
        this.props.setReportReceiptData(reportReceiptData);
      }
      else
      {
        //redux this.setState({reportReceiptData:'', reportLandData});
        reportReceiptData = ''
        this.props.setReportLandData(reportLandData);
        this.props.setReportReceiptData('');
      }

      await sendConfirmationEmail(this.context.reportsEndPoint, reportLandData, reportReceiptData, this.props.Email);
      console.log(reportReceiptData);
      console.log(reportLandData);
      this.hideProgressBar();
    }
    catch (error) {
      console.error("Error in confirm form", error);
    }
    //hideProgressBar();
  };





  handleOnClick = async () => {

    var workAreaDiv = document.getElementById('workArea');
    //workAreaDiv.style.left = '0rem';
    workAreaDiv.style.backgroundColor = 'rgba(128, 128, 128, 0.5)';

    var wrapper = document.getElementById('LandRegistryWrapper');
    wrapper.style.visibility = 'hidden';
    

    var contentElement = document.getElementById('Content');
    contentElement.style.visibility = 'hidden';
    showProgressBar();

    let {reportReceiptData, reportLandData} = this.props;

    reportLandData = await getLandRegistarReport(this.props.propertyNum);
    
    let isZilmisUser = this.props.OwnerId > 0 ? 1 : 0;
    let recieptId = this.props.ReceiptId;
    let billingDetails = this.props.BillingDetails;

    console.log('PaymentConfirmForm-> isZilmisUser: ' + isZilmisUser + ',recieptId: ' + recieptId + ',billingDetails: '+ billingDetails);

    reportReceiptData = await getlandRegistarReceipt(this.context.reportsEndPoint, isZilmisUser,recieptId,billingDetails);
      
    //redux this.setState({reportReceiptData, reportLandData});
    this.props.setReportLandData(reportLandData);
    this.props.setReportReceiptData(reportReceiptData);

    console.log(reportReceiptData);
    console.log(reportLandData);

    hideProgressBar();
    wrapper.style.visibility = 'visible';
    contentElement.style.visibility = 'visible';
    workAreaDiv.style.backgroundColor = '';
  };

  handleOnClick_LndReg = async () =>{
    const link = document.getElementById("LinkLandReport");
    link.target = '_blank';
    link.click();

    /*
    showProgressBar();
    let {reportData} = this.state.reportData;
    reportData = await getLandRegistarReport(this.props.propertyNum);

    if (reportData) {
        this.setState({ reportData }, () => {
        hideProgressBar();
        const link = document.getElementById("LinkReport");
        link.target = '_blank';
        link.click();
        //window.focus();
        });
         }
    */
          

      //***************************************************** */
      //var pdfUrl = "/Reports/Report_ONSV_RE_1133.pdf";
      //console.log(pdfUrl);
      //this.downloadPdf(pdfUrl);
      //***************************************************** */

        //***************************************************** */
        //const newTab = window.open(this.state.reportData, '_blank');
        //if (newTab) {
          //newTab.focus();
        //} else {
          // Popup blocked, handle accordingly
          //console.error('Popup blocked. Please enable popups for this site.');
        //***************************************************** */
        

      //***************************************************** */
      //const link = document.getElementById("Link2");
      //link.href = reportData;
      //link.click();
      //***************************************************** */
   
    //hideProgressBar();
  };



  handleOnClick_Receipt = async () =>{
    //showProgressBar();

    const link = document.getElementById("LinkReceiptReport");

    if (link && typeof link.href === "string" && link.href.trim() !== "" && link.href !== window.location.href) {
        link.target = '_blank';
        link.click();
      } else {
        console.warn("Download link is missing or invalid. No action taken.");
      }

    /*
    let isZilmisUser = this.props.OwnerId > 0 ? 1 : 0;
    let recieptId = this.props.ReceiptId;
    let billingDetails = this.props.BillingDetails;

    console.log('PaymentConfirmForm-> isZilmisUser: ' + isZilmisUser + ',recieptId: ' + recieptId + ',billingDetails: '+ billingDetails);

    try {
      const reportData = await getlandRegistarReceipt(this.context.reportsEndPoint, isZilmisUser,recieptId,billingDetails);
      console.log(reportData);
      this.openReportTab(reportData);
    } catch (error) {
      console.error("Error retrieving or downloading the file:", error);
    } finally {
        hideProgressBar();
    }
    */

   


    //console.log(reportData)
    //var pdfUrl = reportData.replace("https://www.onlineservices.mol.anambrastate.org/WebReports.CR.Service", "");

    //document.getElementById("Link3").click();
    //window.open("/Reports/Report_ONSV_RE_482.pdf", "_blank");
    //window.location.href = "/Reports/Report_ONSV_RE_482.pdf";

    //var pdfUrl = "/Reports/Report_ONSV_RE_482.pdf";
    
  };

  render() {
    let feeValueRenderString = this.props.feeValue.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    let propertyName = this.props.propertyNum ?? "";
    let propertyNameShort = '';
    let paymentMethod = 'Online';
    let deliveryType = 'Digital print';
    const { isLoading } = this.props;
    //let {reportData} = this.state.reportData;

    let {reportLandData} = this.props.reportLandData;
    let {reportReceiptData} = this.props.reportReceiptData ?? "";
    if(propertyName.length > 11)
    {
      propertyNameShort = propertyName.substring(0, 9) + " ...";
    }
    
    return (
      <React.Fragment>
        <div>
          {isLoading && (
          <div className="spinner-modal">
            <div className="spinner-overlay"></div>
            <div className="spinner-container">

            </div>
          </div>
        )}
        </div>

        <div className="text-black">
          <div className="h6 PaymentTitle">
            Your payment was <span id="PaymentSuccessBold">successfully</span>{" "}
            approved. <br />
            You can now download your printout and your receipt.
          </div>
        </div>
        <MobileView>
          <div className="SearchLandResults">
              {/* <div className="ResultRow">
                <div className="ColumnTitle">Property No.</div>
                <div className="SearchResultItem">
                {propertyName.length > 11 ? (
                  <ShortValueField
                    shortValue={propertyNameShort}
                    fullValue={propertyName}
                  />
                ) : (
                  <div>{propertyName}</div>
                )}
                </div>
              </div> */}
              <div className="ResultRow">
                <div className="ColumnTitle1">Delivery</div>
                <div className="SearchResultItem1">{deliveryType}</div>
              </div>
              <div className="ResultRow">
                <div className="ColumnTitle1">Payment</div>
                <div className="SearchResultItem1">{paymentMethod}</div>
              </div>
              <div className="ResultRow">
                <div className="ColumnTitle1">Cost (₦)</div>
                <div className="SearchResultItem1">{feeValueRenderString}</div>
              </div>
          </div>
        </MobileView>
        <BrowserView>
          <div id="PaymentConfirmDetails">
            <div id="SearchResultTitles">
              {/* <div className="ColumnTitle">Property No.</div> */}
	            <div className="ColumnTitle1">Delivery</div>
	            <div className="ColumnTitle1">Payment</div>
	            <div className="ColumnTitle1">Cost (₦)</div>
            </div>
            <div id="SearchResultData">
              {/* <div className="SearchResultItem">
                {propertyName.length > 11 ?
                (<ShortValueField
                  shortValue={propertyNameShort}
                  fullValue={propertyName}
                />)
                : (<div>{propertyName}</div>)
                }
              </div> */}
              <div className="SearchResultItem1">Digital print</div>
            <div className="SearchResultItem1">Online</div>
            <div className="SearchResultItem1">{feeValueRenderString}</div>
            </div>
          </div>          
        </BrowserView>
        
        <div className="ButtonWrapper2">
          <button id="Btn_LandReg" className="btnLndReg" autoFocus onClick={this.handleOnClick_LndReg}>
            Download Printout
          </button>
          <button id="Btn_Receipt" className="btnReceipt" autoFocus onClick={this.handleOnClick_Receipt}>
            Download Receipt
          </button>
          

          
            
          
          {/*
          <div>
            <a
              //target="_blank"
              href="/Reports/Report_ONSV_RE_482.pdf"
              id="Link2"
              //style={{ display: "none" }}
              //rel="noopener noreferrer"
            >
              {"second link"}
            </a>

            <a
              target="_blank"
              id="Link3"
              href="/Reports/Report_ONSV_RE_482.pdf"
              //id="ReportDownloadLink"
              //style={{ display: "none" }}
              //rel="noopener noreferrer"
            >
              {"3eme link"}
            </a>
          </div>*/}

          {/* <a
            target="_WORD"
            href=""
            id="ReportDownloadLink1"
            //style={{ display: "none" }}
          >
            111
          </a> */}
        </div>
        

        
        <a
          target="_blank"
          href={this.props.reportReceiptData}
          id="LinkReceiptReport"
          style={{ display: "none" }}
          //rel="noopener noreferrer"
        >
          {"Download Receipt Report"}
        </a>

        <a
          target="_blank"
          href={this.props.reportLandData}
          id="LinkLandReport"
          style={{ display: "none" }}
          //rel="noopener noreferrer"
        >
          {"Download Land Printout"}
        </a>

      </React.Fragment>
    );
  }
}


// Redux state → props
const mapStateToProps = (state) => {
  const landSearch = state.landSearch;
  const payment = state.payment;

  return {
    // from landSearch slice

     // from payment slice
    Email: payment.data.Email,
    LandId: payment.data.LandId,
    feeValue: payment.data.feeValue,
    isLoading: payment.isLoading,
    reportLandData: payment.reportLandData,
    reportReceiptData: payment.reportReceiptData,
  };
};

// Dispatch → props
const mapDispatchToProps = {
  setIsLoading,
  setReportReceiptData,
  setReportLandData
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentConfirmForm);

//export default PaymentConfirmForm;
